import { BuildClass } from '../../universal';
import { React, _ } from '../lib';
import { CJSX, LoadingSpinnerLarge, LoadingSpinnerSmall } from './ui5';
export const LoadingSpinnerProgress = (props) => {
    const cache = {
        sectionPathsOrder: [],
        sectionPaths: {},
    };
    if (props.report == null) {
        return React.createElement(LoadingSpinnerLarge, null);
    }
    const report = props.report;
    const paths = [];
    const getSectionPath = (parents, section) => {
        const this_path = parents.concat(section.Key);
        paths.push(this_path);
        section.Sections?.forEach(x => {
            getSectionPath(this_path, x);
        });
    };
    report.Sections.forEach(x => {
        getSectionPath([], x);
    });
    cache.sectionPathsOrder = _.compact(paths.map(x => x[x.length - 1]));
    cache.sectionPaths = _.mapKeys(paths, x => x[x.length - 1]);
    const buildList = (sections) => (React.createElement("ul", { className: "list" }, _.map(sections, x => (React.createElement("li", { key: x.Key },
        buildIndicator(x.Key, report),
        React.createElement("span", null, x.Name),
        x.Sections ? buildList(x.Sections) : React.createElement(React.Fragment, null))))));
    const buildIndicator = (key, report) => {
        const is_current = report.Section === key;
        const is_child_current = Array.from(cache.sectionPaths[report.Section] ?? []).includes(key);
        let has_passed = false;
        if (!is_child_current && !is_current) {
            const selected_section = cache.sectionPathsOrder.indexOf(report.Section);
            const this_section = cache.sectionPathsOrder.indexOf(key);
            has_passed = this_section < selected_section;
        }
        let percentage = Math.round((report.Progress / report.Total) * 100);
        if (percentage === Infinity || isNaN(percentage)) {
            percentage = -1;
        }
        return (React.createElement("span", { className: BuildClass({
                indicator: true,
                complete: has_passed,
            }) },
            React.createElement("span", { className: BuildClass({
                    'sub-indicator spinner': true,
                    semi: !is_current,
                    hidden: !(is_current || is_child_current) ||
                        (is_current && percentage !== -1),
                }) },
                React.createElement(LoadingSpinnerSmall, null)),
            React.createElement("span", { className: BuildClass({
                    'sub-indicator perc': true,
                    hidden: percentage === -1 || !is_current,
                }) },
                percentage,
                "%"),
            React.createElement("span", { className: BuildClass({
                    'sub-indicator completion': true,
                    hidden: !has_passed || is_current || is_child_current,
                }) }, "\u2714")));
    };
    return (React.createElement("div", { className: "loading-progress-pane" },
        React.createElement("div", { className: BuildClass({
                'progress-details': true,
                hidden: report == null,
            }) },
            React.createElement(CJSX, { cond: report?.Sections != null }, buildList(report.Sections))),
        React.createElement("div", { className: BuildClass({
                'pre-progress': true,
                hidden: report != null,
            }) },
            React.createElement(LoadingSpinnerLarge, null))));
};
//# sourceMappingURL=component-progress.js.map